import { Box, Collapse, Link, Stack, Typography } from '@mui/material'
import OpenCloseButton from 'components/openCloseButton/OpenCloseButton'
import SectionContainer from 'containers/dashboard/components/SectionContainer'
import SectionHeader from 'containers/dashboard/components/SectionHeader'
import { useState } from 'react'

type Props = {
  targetCompanyName: string
}
export default function UnderstandingSection({ targetCompanyName }: Props) {
  const [sectionOpened, setSectionOpened] = useState(false)
  return (
    <SectionContainer>
      <SectionHeader>
        <Typography color={'normalGrey.main'} fontSize={15}>
          {' '}
          What is the Competitive Strength Gap and how is it calculated ?
        </Typography>

        <OpenCloseButton onClick={() => setSectionOpened(!sectionOpened)} opened={sectionOpened} />
      </SectionHeader>
      <Collapse in={sectionOpened}>
        <Box px={3} pb={3}>
          <Typography color="normalGrey.main" variant="body2">
            Insights IDS identifies {targetCompanyName}’s IP portfolio and applies decision algorithms to isolate its dominant
            innovation areas, filtering out less relevant or weakly represented sectors. This creates a clear and focused IP
            boundary for comparing competitor portfolios. It then calculates a Pure Play % score for each competitor, measuring
            overlap with the core IP. The Competitive Strength Gap shows how far ahead {targetCompanyName} is compared to the top
            10 most focused rivals in those areas.
          </Typography>

          <Link href="/resources/strategic-focus-gap" target="_blank">
            <Typography pt={2} variant="body2">
              Go to Understanding the Competitive Strength Gap
            </Typography>
          </Link>
        </Box>
      </Collapse>
    </SectionContainer>
  )
}
